import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [0.59954691495],
    [0.09695898711, 5.06191793105, 529.6909650946],
    [0.00573610145, 1.44406205976, 7.1135470008],
    [0.0030638918, 5.41734729976, 1059.3819301892],
    [0.0009717828, 4.14264708819, 632.7837393132],
    [0.00072903096, 3.64042909255, 522.5774180938],
    [0.00064263986, 3.41145185203, 103.0927742186],
    [0.00039806051, 2.29376744855, 419.4846438752],
    [0.0003885778, 1.2723172486, 316.3918696566],
    [0.00027964622, 1.78454589485, 536.8045120954],
    [0.00013589738, 5.7748103159, 1589.0728952838],
    [0.00008768686, 3.63000324417, 949.1756089698],
    [0.00008246362, 3.58227961655, 206.1855484372],
    [0.00007368057, 5.08101125612, 735.8765135318],
    [0.00006263171, 0.02497643742, 213.299095438],
    [0.0000611405, 4.51319531666, 1162.4747044078],
    [0.00005305457, 4.18625053495, 1052.2683831884],
    [0.00005305283, 1.30671236848, 14.2270940016],
    [0.00004905419, 1.32084631684, 110.2063212194],
    [0.00004647249, 4.69958109497, 3.9321532631],
    [0.00003045009, 4.31675960318, 426.598190876],
    [0.00002610001, 1.5666759485, 846.0828347512],
    [0.00002028191, 1.06376547379, 3.1813937377],
    [0.00001920959, 0.97168928755, 639.897286314],
    [0.00001764768, 2.14148077766, 1066.49547719],
    [0.00001722983, 3.88036008872, 1265.5674786264],
    [0.00001633217, 3.58201089758, 515.463871093],
    [0.00001431997, 4.29683690269, 625.6701923124],
    [0.00000973278, 4.09764957065, 95.9792272178],
    [0.00000884439, 2.43701426123, 412.3710968744],
    [0.00000732875, 6.08534113239, 838.9692877504],
    [0.00000731072, 3.80591233956, 1581.959348283],
    [0.0000070919, 1.29272573658, 742.9900605326],
    [0.00000691928, 6.13368222939, 2118.7638603784],
    [0.00000614464, 4.10853496756, 1478.8665740644],
    [0.00000581902, 4.53967717552, 309.2783226558],
    [0.00000495224, 3.75567461379, 323.5054166574],
    [0.00000440854, 2.95818460943, 454.9093665273],
    [0.00000417266, 1.03554430161, 2.4476805548],
    [0.00000389864, 4.89716105852, 1692.1656695024],
    [0.00000375657, 4.70299124833, 1368.660252845],
    [0.00000341006, 5.71452525783, 533.6231183577],
    [0.00000330458, 4.74049819491, 0.0481841098],
    [0.0000026154, 1.87652461032, 0.9632078465],
    [0.00000261009, 0.82047246448, 380.12776796],
    [0.00000256568, 3.72410724159, 199.0720014364],
    [0.0000024417, 5.220208789, 728.762966531],
    [0.00000235141, 1.22693908124, 909.8187330546],
    [0.00000220382, 1.65115015995, 543.9180590962],
    [0.00000207327, 1.85461666594, 525.7588118315],
    [0.00000201996, 1.80684574186, 1375.7737998458],
    [0.00000197046, 5.29252149016, 1155.361157407],
    [0.00000175191, 3.72966554761, 942.062061969],
    [0.00000175184, 3.22634903433, 1898.3512179396],
    [0.00000174809, 5.90973505276, 956.2891559706],
    [0.00000157909, 4.36483921766, 1795.258443721],
    [0.00000150502, 3.90625022622, 74.7815985673],
    [0.00000149368, 4.37745104275, 1685.0521225016],
    [0.00000141445, 3.13568357861, 491.5579294568],
    [0.00000137871, 1.31797920785, 1169.5882514086],
    [0.00000130531, 4.16867945489, 1045.1548361876],
    [0.00000117495, 2.5002214089, 1596.1864422846],
    [0.00000116757, 3.38920921041, 0.5212648618],
    [0.00000105895, 4.55439798236, 526.5095713569],
];

const VSOP87_L1: Vsop87Element = [
    [529.93480757497],
    [0.00489741194, 4.22066689928, 529.6909650946],
    [0.00228918538, 6.02647464016, 7.1135470008],
    [0.0002765538, 4.57265956824, 1059.3819301892],
    [0.00020720943, 5.45938936295, 522.5774180938],
    [0.00012105732, 0.16985765041, 536.8045120954],
    [0.00006068051, 4.42419502005, 103.0927742186],
    [0.00005433924, 3.98478382565, 419.4846438752],
    [0.00004237795, 5.89009351271, 14.2270940016],
    [0.00002211854, 5.26771446618, 206.1855484372],
    [0.00001745919, 4.92669378486, 1589.0728952838],
    [0.00001295769, 5.55132765087, 3.1813937377],
    [0.00001173129, 5.8564730435, 1052.2683831884],
    [0.00001163411, 0.51450895328, 3.9321532631],
    [0.00001098735, 5.30704981594, 515.463871093],
    [0.00001007216, 0.46478398551, 735.8765135318],
];

const VSOP87_L2: Vsop87Element = [
    [0.00047233598, 4.32148323554, 7.1135470008],
    [0.0003896555],
    [0.00030629053, 2.93021440216, 529.6909650946],
    [0.00003189317, 1.05504615595, 522.5774180938],
    [0.00002729292, 4.84545481351, 536.8045120954],
    [0.00002723358, 3.41411526638, 1059.3819301892],
    [0.00001721069, 4.18734385158, 14.2270940016],
    [0.00000383258, 5.76790714387, 419.4846438752],
    [0.00000377524, 0.76048964872, 515.463871093],
];

const VSOP87_L3: Vsop87Element = [
    [0.00006501665, 2.59862880482, 7.1135470008],
    [0.00001356524, 1.34635886411, 529.6909650946],
    [0.00000470716, 2.47503977883, 14.2270940016],
];

const VSOP87_L4: Vsop87Element = [[0.00000669483, 0.8528242109, 7.1135470008]];

const VSOP87_L5: Vsop87Element = [];

const VSOP87_B0: Vsop87Element = [
    [0.02268615703, 3.55852606718, 529.6909650946],
    [0.00110090358],
    [0.00109971634, 3.90809347389, 1059.3819301892],
    [0.00008101427, 3.60509573368, 522.5774180938],
    [0.00006437782, 0.30627121409, 536.8045120954],
    [0.00006043996, 4.25883108794, 1589.0728952838],
    [0.0000110688, 2.98534421928, 1162.4747044078],
    [0.00000944328, 1.67522288396, 426.598190876],
    [0.00000941651, 2.93619072405, 1052.2683831884],
    [0.00000894088, 1.75447429921, 7.1135470008],
    [0.00000835861, 5.17881973234, 103.0927742186],
    [0.0000076728, 2.1547359406, 632.7837393132],
    [0.0000068422, 3.67808770098, 213.299095438],
    [0.00000629223, 0.64343282328, 1066.49547719],
    [0.00000558524, 0.01354830508, 846.0828347512],
    [0.0000053167, 2.70305954352, 110.2063212194],
    [0.00000464449, 1.17337249185, 949.1756089698],
    [0.00000431072, 2.60825000494, 419.4846438752],
    [0.00000351433, 4.61062990714, 2118.7638603784],
    [0.0000013216, 4.7781699067, 742.9900605326],
    [0.00000123148, 3.34968181384, 1692.1656695024],
    [0.00000116379, 1.38688232033, 323.5054166574],
    [0.00000115038, 5.04892295442, 316.3918696566],
    [0.00000103762, 3.7010383811, 515.463871093],
    [0.00000103402, 2.31878999565, 1478.8665740644],
    [0.0000010242, 3.15293785436, 1581.959348283],
];

const VSOP87_B1: Vsop87Element = [
    [0.00177351787, 5.70166488486, 529.6909650946],
    [0.00003230171, 5.7794161934, 1059.3819301892],
    [0.00003081364, 5.47464296527, 522.5774180938],
    [0.00002211914, 4.73477480209, 536.8045120954],
    [0.00000346445, 4.74595174109, 1052.2683831884],
    [0.00000234264, 5.18856099929, 1066.49547719],
    [0.00000196154, 6.18554286642, 7.1135470008],
    [0.00000150468, 3.92721226087, 1589.0728952838],
    [0.00000114128, 3.4389727183, 632.7837393132],
];

const VSOP87_B2: Vsop87Element = [
    [0.00008094051, 1.46322843658, 529.6909650946],
    [0.00000742415, 0.95691639003, 522.5774180938],
    [0.00000398951, 2.89888666447, 536.8045120954],
    [0.00000342226, 1.44683789727, 1059.3819301892],
    [0.00000073948, 0.40724675866, 1052.2683831884],
    [0.00000046151, 3.48036895772, 1066.49547719],
];

const VSOP87_B3: Vsop87Element = [
    [0.00000251624, 3.38087923084, 529.6909650946],
    [0.00000121738, 2.733118372, 522.5774180938],
];

const VSOP87_B4: Vsop87Element = [[0.0000001505, 4.52956999637, 522.5774180938]];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [5.20887429471],
    [0.2520932702, 3.49108640015, 529.6909650946],
    [0.00610599902, 3.84115365602, 1059.3819301892],
    [0.00282029465, 2.57419879933, 632.7837393132],
    [0.00187647391, 2.07590380082, 522.5774180938],
    [0.00086792941, 0.71001090609, 419.4846438752],
    [0.00072062869, 0.21465694745, 536.8045120954],
    [0.00065517227, 5.97995850843, 316.3918696566],
    [0.00030135275, 2.16132058449, 949.1756089698],
    [0.0002913462, 1.6775924371, 103.0927742186],
    [0.0002394734, 0.27457854894, 7.1135470008],
    [0.00023453209, 3.54023147303, 735.8765135318],
    [0.0002228371, 4.19362773546, 1589.0728952838],
    [0.000130326, 2.96043055741, 1162.4747044078],
    [0.00012749004, 2.71550102862, 1052.2683831884],
    [0.00009703346, 1.90669572402, 206.1855484372],
    [0.00009161431, 4.41352618935, 213.299095438],
    [0.00007894539, 2.47907551404, 426.598190876],
    [0.00007057978, 2.18184753111, 1265.5674786264],
    [0.00006137755, 6.26417542514, 846.0828347512],
    [0.00005477093, 5.65729325169, 639.897286314],
    [0.00004170012, 2.01605033912, 515.463871093],
    [0.0000413689, 2.72219979684, 625.6701923124],
    [0.00003502519, 0.56531297394, 1066.49547719],
    [0.00002616955, 2.00993967129, 1581.959348283],
    [0.00002499966, 4.55182055941, 838.9692877504],
    [0.00002127644, 6.1275146175, 742.9900605326],
    [0.00001911876, 0.85621927419, 412.3710968744],
    [0.00001610549, 3.08867789275, 1368.660252845],
    [0.00001479484, 2.68026191372, 1478.8665740644],
    [0.00001230708, 1.89042979701, 323.5054166574],
    [0.0000121681, 1.80171561024, 110.2063212194],
    [0.00001014959, 1.38673237666, 454.9093665273],
    [0.00000998579, 2.8720894011, 309.2783226558],
    [0.00000961072, 4.54876989805, 2118.7638603784],
    [0.00000885708, 4.14785948471, 533.6231183577],
    [0.00000821465, 1.59342534396, 1898.3512179396],
    [0.00000812036, 5.94091899141, 909.8187330546],
    [0.000007767, 3.6769695469, 728.762966531],
    [0.00000727162, 3.98824686402, 1155.361157407],
    [0.00000655289, 2.79065604219, 1685.0521225016],
    [0.00000653981, 3.38150775269, 1692.1656695024],
    [0.00000620798, 4.82284338962, 956.2891559706],
    [0.00000614784, 2.27624915604, 942.062061969],
];

const VSOP87_R1: Vsop87Element = [
    [0.01271801596, 2.64937511122, 529.6909650946],
    [0.00061661771, 3.00076251018, 1059.3819301892],
    [0.00053443592, 3.89717644226, 522.5774180938],
    [0.00041390257],
    [0.00031185167, 4.88276663526, 536.8045120954],
    [0.0001184719, 2.41329588176, 419.4846438752],
    [0.0000916636, 4.75979408587, 7.1135470008],
    [0.00003403605, 3.34688537997, 1589.0728952838],
    [0.00003203446, 5.21083285476, 735.8765135318],
    [0.00003175763, 2.79297987071, 103.0927742186],
    [0.00002806064, 3.7422369358, 515.463871093],
    [0.00002676575, 4.33052878699, 1052.2683831884],
    [0.00002600003, 3.63435101622, 206.1855484372],
    [0.00002412207, 1.46947308304, 426.598190876],
    [0.00002100507, 3.92762682306, 639.897286314],
    [0.00001646182, 5.30953510947, 1066.49547719],
    [0.00001641257, 4.41628669824, 625.6701923124],
    [0.00001049866, 3.16113622955, 213.299095438],
];

const VSOP87_R2: Vsop87Element = [
    [0.00079644833, 1.35865896596, 529.6909650946],
    [0.00008251618, 5.77773935444, 522.5774180938],
    [0.00007029864, 3.27476965833, 536.8045120954],
    [0.00005314006, 1.83835109712, 1059.3819301892],
    [0.00001860833, 2.97682139367, 7.1135470008],
    [0.00000964466, 5.48031822015, 515.463871093],
    [0.00000836267, 4.19889881718, 419.4846438752],
    [0.0000042657, 2.22753101795, 639.897286314],
    [0.00000406453, 3.78250730354, 1066.49547719],
];

const VSOP87_R3: Vsop87Element = [
    [0.00003519257, 6.05800633846, 529.6909650946],
    [0.00001073239, 1.6732134576, 536.8045120954],
    [0.00000915666, 1.41329676116, 522.5774180938],
];

const VSOP87_R4: Vsop87Element = [[0.00000128628, 0.08419309557, 536.8045120954]];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
